import React from "react";

import { ProductDetailPageBlocks as Value, templates } from "@reactivated";

import {
    StreamField,
    StreamFieldBlockMap,
} from "@thelabnyc/thelabui/src/components/StreamField";

import { PageSkeleton } from "../components/PageSkeleton";
import { toolboxComponents } from "../components/PageSkeleton/Toolbox";
import {
    ScrollNavMenu,
    ScrollNavMenuItemBlock,
} from "../components/ScrollNavMenuBlock";
import { SlidingCardsBlock } from "../components/SlidingCardsBlock";
import { SplitPanelCardsBlock } from "../components/SplitPanelCardsBlock";

import styles from "../styles/pdp.module.scss";

export const blocks: StreamFieldBlockMap<Value> = {
    nav_menu: ScrollNavMenu,
    nav_menu_item: ScrollNavMenuItemBlock,
    sliding_cards: SlidingCardsBlock,
    split_panel_cards: SplitPanelCardsBlock,
    ...toolboxComponents,
};

export const Template = (props: templates.ProductDetailPageTemplate) => {
    return (
        <PageSkeleton
            {...props.page}
            sticky_nav={false}
            rootClassName={styles.pdp}
        >
            <StreamField
                tagName={React.Fragment}
                components={blocks}
                value={props.page.body.value}
            />
        </PageSkeleton>
    );
};
